/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Common_Auth_Gate_Action_SubmitInputs */

const en_common_auth_gate_action_submit = /** @type {(inputs: Common_Auth_Gate_Action_SubmitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`submit your product`)
};

const zh_common_auth_gate_action_submit = /** @type {(inputs: Common_Auth_Gate_Action_SubmitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`提交你的产品`)
};

/**
* | output |
* | --- |
* | "submit your product" |
*
* @param {Common_Auth_Gate_Action_SubmitInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const common_auth_gate_action_submit = /** @type {((inputs?: Common_Auth_Gate_Action_SubmitInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Common_Auth_Gate_Action_SubmitInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_common_auth_gate_action_submit(inputs)
	return zh_common_auth_gate_action_submit(inputs)
});
export { common_auth_gate_action_submit as "common.auth.gate.action.submit" }